import firebase from './firebase';

// Saving an album attaches it to the person's account without making them a credited artist:
// `users/<username>/savedAlbums/<albumId> = ms saved`. It is separate from `users/<username>/albums`,
// which holds albums the person is credited on (and the older "listener" entries that are being phased out).
// Removing a saved album only forgets this entry (plus the legacy listener entry and the pin/opened
// markers); the album itself and its songs are never touched.

const userRef = (username) => firebase.database().ref('users').child(username);

export const saveAlbumFor = (username, albumId) => userRef(username).child('savedAlbums').child(albumId).set(Date.now());

export const removeAlbumFor = (username, albumId) => firebase.database().ref().update({
  [`users/${username}/savedAlbums/${albumId}`]: null,
  [`users/${username}/albums/${albumId}`]: null,
  [`users/${username}/pinnedAlbums/${albumId}`]: null,
  [`users/${username}/albumOpened/${albumId}`]: null,
});

// True when the album is already in the person's library (saved, credited or an older listener entry).
export const hasAlbum = async (username, albumId) => {
  const [saved, credited] = await Promise.all(['savedAlbums', 'albums']
    .map((node) => userRef(username).child(node).child(albumId).once('value')));
  return saved.exists() || credited.exists();
};

// Where to send someone after they log in or sign up. Only same-site album links are allowed, so the
// `next` parameter can't be used to send people elsewhere.
export const nextPath = (search) => {
  const next = new URLSearchParams(search || '').get('next') || '';
  return /^\/a\/[^/?#]+(\?save=1)?$/.test(next) ? next : '';
};

// The login link that brings someone back to this album and saves it once they are in.
export const loginToSave = (albumId) => `/login?next=${encodeURIComponent(`/a/${albumId}?save=1`)}`;
